<script>
/* -------------------------------------------------------------------------------------
The navigation bar displays the different available panels. Most functions are only 
available when the user is logged in.

Main components
---------------
Methods:
- logout: logs user out
---------------------------------------------------------------------------------------*/

import { authComputed } from '@/vuex/helpers.js'

export default {
  computed: {
    ...authComputed // return true if user is logged in
  },

  data: () => ({
    userMenuItems: [{ title: 'Profile' }, { title: 'Log Out' }], // Available user sub menus    
  }),

  methods: {

    // evaluate which sub-menu was chosen below 'User'
    userMenuSelected(index) {
      if (index === 1) {
        // logs user out
        this.$store.dispatch('user/logout')
      } else {
        this.$router.push({ name: 'view-user' })
      }
    },
  }
}
</script>

<template>
  <div id="nav">

    <v-app-bar app color="#000033" dark>

      <v-toolbar-title class="logo">
        tour
        <em class="logo_em">DB</em>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>
      
      <v-btn text rounded v-if="loggedIn" :to="{ name: 'view-dashboard' }"
        >Dashboard</v-btn
      >

      <v-btn text rounded v-if="loggedIn" :to="{ name: 'view-map' }"
        >Map</v-btn
      >

      <v-spacer></v-spacer>
      
      <v-btn text rounded :to="{ name: 'view-about' }">About</v-btn>

      <v-menu offset-y v-if="loggedIn">

        <template v-slot:activator="{ on, attrs }">
          <v-btn text rounded dark v-bind="attrs" v-on="on">
            User
          </v-btn>
        </template>
        
        <v-list>
          <v-list-item
            v-for="(item, index) in userMenuItems"
            :key="index"
            @click="userMenuSelected(index)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>

      </v-menu>
      
      <v-btn v-if="!loggedIn" :to="{ name: 'view-login' }" class="button"
        >Login</v-btn
      >

    </v-app-bar>
  </div>
</template>

<style scoped>
  .logo {
    margin: 0px;
    font-size: 23pt;
    color: rgb(157, 195, 230);
    float: left;
    margin-left: 20px;
    width: 30%;
  }

  .logo_em {
    font-size: 16pt;
    color: #ffffff;
  }

</style>
